import { asPartialIEnvironment, Env, IEnvironment } from '../environment.interface';
import { environmentBase } from './environment.base';

export const environmentDevLocal: IEnvironment = {
  ...environmentBase,
  ...asPartialIEnvironment({
    environment: Env.DEV,
    baseUrl: 'https://api.backoffice.dev.vivela.io/backoffice',
    authBaseUrl: 'https://auth.backoffice.dev.vivela.io',
    googleAuthClientId: '6iij4o83qgl87i3f8svfv8bce1',
    authCallbackUrl: 'http://localhost:4200/callback',
    recaptchaSiteKey: '6Lf8Ln0hAAAAAIyfpLAYUehtKnQZ-r-SwyV_-7g2',
  }),
};
